export const GtTypes = [
    {
        label: 'Student',
        value: 'Student'
    },
    {
        label: 'Employee',
        value: 'Employee'
    },    {
        label: 'Cooperator',
        value: 'Cooperator'
    },   {
        label: 'hsealumni',
        value: 'hsealumni'
    },
    {
        label: 'Hseyerevanstudent',
        value: 'Hseyerevanstudent'
    },
    {
        label: 'lpuemployee',
        value: 'lpuemployee'
    },
    {
        label: 'greenawards',
        value: 'greenawards'
    },
    {
        label: 'externalhse',
        value: 'externalhse'
    },
    {
        label: 'Hsecreativestudent',
        value: 'Hsecreativestudent'
    },
]export const GtTypes = [
    {
        label: 'Student',
        value: 'Student'
    },
    {
        label: 'Employee',
        value: 'Employee'
    },    {
        label: 'Cooperator',
        value: 'Cooperator'
    },   {
        label: 'hsealumni',
        value: 'hsealumni'
    },
    {
        label: 'Hseyerevanstudent',
        value: 'Hseyerevanstudent'
    },
    {
        label: 'lpuemployee',
        value: 'lpuemployee'
    },
    {
        label: 'greenawards',
        value: 'greenawards'
    },
    {
        label: 'externalhse',
        value: 'externalhse'
    },
    {
        label: 'Hsecreativestudent',
        value: 'Hsecreativestudent'
    },
]